export abstract class BaseComponent extends HTMLElement {
  protected shadow: ShadowRoot | null = null;
  protected isLoading: boolean = false;
  /** Constructs this instance. */


  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadow = this.shadowRoot;
  }
  /** Connected callback. */


  connectedCallback(): void {
    this.render();
    this.setupEventListeners();
  }
  /** Disconnected callback. */


  disconnectedCallback(): void {
    this.removeEventListeners();
  }

  /** Renders the  view. */
    protected abstract render(): void;
  /** Setup event listeners. */


  protected setupEventListeners(): void {
    void 0;
  }
  /** Remove event listeners. */

  protected removeEventListeners(): void {
    void 0;
  }
  /** Execute with loading. */


  protected async executeWithLoading<T>(
    operation: () => Promise<T>,
    onStart?: () => void,
    onEnd?: () => void,
    onError?: (error: Error) => void
  ): Promise<T | void> {
    if (this.isLoading) return;
    this.isLoading = true;
    if (onStart) onStart();
    this.render();

    try {
      const result = await operation();
      return result;
    } catch (error) {
      if (onError) {
        try {
          onError(error as Error);
        } catch {
          /* Swallow buggy onError hooks so `finally` still runs. */
        }
      }
    } finally {
      this.isLoading = false;
      if (onEnd) onEnd();
      this.render();
    }
  }
}
